import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  loading?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, loading = false, ...props }, ref) => {
    return (
      <input
        type={type}
        disabled={loading || props.disabled}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          loading &&
            "animate-pulse bg-muted text-transparent pointer-events-none",
          className
        )}
        ref={ref}
        {...props}
        placeholder={loading ? "" : props.placeholder}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
